import { PaneArea } from '../../types/shared'
import Arrow, { IArrowAttrs } from '../canvas/arrow'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IArrowAttrs
type PartialAttrs = Partial<Attrs>

class ArrowCreator extends Arrow<Attrs> {
  mouseDowns = 1
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = startArea.x
    this.attrs.x2 = startArea.x
    this.attrs.y1 = startArea.y
    this.attrs.y2 = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.mouseDowns++
    if (this.mouseDowns > 1) {
      this.release()
      this.replaceMyself(Arrow.fromObject(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    this.attrs.x1 = area.x
    this.attrs.y1 = area.y
    this.trigger('change')
  }
}

export default ArrowCreator
